import { PaginatedResponse } from '@frontend/api-utils';

export interface SeedIoT {
    id: string;
    service_name?: string;
    count?: number;
}

export type IoTSeedListResponse = PaginatedResponse<SeedIoT>;

export enum IoTServiceName {
    ACCOUNT_API = 'account-api',
    AUTHORIZATION_API = 'authorization-api',
    BUDGET_API = 'budget-api',
    CERTIFICATE_API = 'certificate-api',
    COST_CENTER_API = 'cost-center-api',
    DEVICE_API = 'device-api',
    DOCUMENT_API = 'document-api',
    EQUIPMENT_API = 'equipment-api',
    GROUP_API = 'group-api',
    IDENTIFICATION_API = 'identification-api',
    IOT_API = 'iot-api',
    LOCKER_API = 'locker-api',
    MODULE_API = 'module-api',
    PACKAGE_API = 'package-api',
    PROBLEM_API = 'problem-api',
    PRODUCT_API = 'product-api',
    QUESTION_API = 'question-api',
    SETTING_API = 'setting-api',
    SLOT_API = 'slot-api',
    SPOT_API = 'spot-api',
    STOCK_API = 'stock-api',
    TRANSACTION_API = 'transaction-api',
    USER_API = 'user-api',
    WORKFLOW_API = 'workflow-api'
}
